export const defaultCardArt = `/cardArt/syf_generic_card.svg`;
export const routingAccountNumbers = (lang) => `/makeapayment/${lang}/routing_account_numbers.svg`;
export const autopayConfirmationImg = '/makeapayment/images/autopay/autopay_confirmation.svg';
export const autopayErrorImage = '/makeapayment/images/autopay/autopay_error.svg';
// payment methods
export const visaCardMiniImg = '/makeapayment/paymentmethods/visamini.svg';
export const masterCardMiniImg = '/makeapayment/paymentmethods/mastercardmini.svg';
export const discoverCardMiniImg = '/makeapayment/paymentmethods/discovermini.svg';
export const securityCodeImage = (lang) => `/makeapayment/paymentmethods/securitycodeimage-${lang}.svg`;
export const defaultCardImg = `/makeapayment/paymentmethods/carddefault.svg`;
export const sleepyCatImg = '/makeapayment/images/sleepy_cat.svg';
// CAP/settlement
export const handHeartImage = '/makeapayment/images/heart-hand.svg';
